var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKinesthetic = function SvgKinesthetic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 50l50 50 50-50zm0 2.777l47.225 47.225L50 97.225 2.775 50.002zm0 2.677L5.454 50.002 50 94.548l44.546-44.546L50 5.454zm0 6.945l37.601 37.603L50 87.603 12.399 50.002 50 12.399zm13.333 21.32l-19.554 5.432v16.767A5.323 5.323 0 0042 55.614a5.334 5.334 0 105.333 5.333V45.409l12.443-3.556v9.622A5.323 5.323 0 0058 51.17a5.332 5.332 0 00-5.331 5.333 5.332 5.332 0 1010.665 0z",
    fill: "#f0cf75",
    fillOpacity: 1,
    strokeWidth: 0.036
  })));
};

export default SvgKinesthetic;